var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"experience"}},[_c('h3',[_c('span',[_vm._v(_vm._s(_vm.year))]),_vm._v(" "),_c('br'),_vm._v(" "+_vm._s(_vm.place)+" ")]),_c('p',[_vm._v(_vm._s(_vm.description))])])}
var staticRenderFns = []

export { render, staticRenderFns }